<template>
	<div class="clients">
		<div>
			<b-card no-body>
				<b-tabs pills card vertical>
					<!--b-tab title="Consultar" active>
            <list-clients></list-clients>
					</b-tab-->
					<b-tab title="Adicionar">
            <new-client></new-client>
					</b-tab>
				</b-tabs>
			</b-card>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import newClient from '../components/Clients/newClient.vue'
//import listClients from '../components/Clients/listClients.vue'
export default {
	name: "clients",
	data() {
		return {
		}
	},
	components: {
    newClient
	}
}
</script>

<style lang='css'>
.clients a {
  color: #53574D !important;
}
</style>
